import { RECORDER_RESOLUTIONS } from './constants';
import { Resolution } from './recorder/RecorderVideo';

export const getRecorderResolution = (value: Maybe<string>): Resolution => {
    if (value && value in RECORDER_RESOLUTIONS) {
        return RECORDER_RESOLUTIONS[value];
    }

    return RECORDER_RESOLUTIONS[1080];
};
